import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CondolenceLogin from './pages/CondolenceLogin';
import CondolenceMenu from './pages/CondolenceMenu';
import CondolenceCreate from './pages/CondolenceCreate';
import CondolenceHistory from './pages/CondolenceHistory';
import CondolenceHistoryAll from './pages/CondolenceHistoryAll';
import CondolenceFlower from './pages/CondolenceFlower';
import CondolenceAdmin from './pages/CondolenceAdmin';
import CondolenceSubmit from './pages/CondolenceSubmit';
import CondolencePasswordChange from './pages/CondolencePasswordChange';
import CondolencePasswordAdmin from './pages/CondolencePasswordAdmin';
import CondolenceObituaryRecipients from './pages/CondolenceObituaryRecipients';
import CondolenceMailGroups from './pages/CondolenceMailGroups';
import CondolenceEmployeeMaster from './pages/CondolenceEmployeeMaster';
import CondolenceInvite from './pages/CondolenceInvite';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/condolence" element={<CondolenceLogin />} />
        <Route path="/condolence/menu" element={<CondolenceMenu />} />
        <Route path="/condolence/create" element={<CondolenceCreate />} />
        <Route path="/condolence/history" element={<CondolenceHistory />} />
        <Route path="/condolence/history-all" element={<CondolenceHistoryAll />} />
        <Route path="/condolence/flower" element={<CondolenceFlower />} />
        <Route path="/condolence/admin" element={<CondolenceAdmin />} />
        <Route path="/condolence/submit" element={<CondolenceSubmit />} />
        <Route path="/condolence/change-password" element={<CondolencePasswordChange />} />
        <Route path="/condolence/password-admin" element={<CondolencePasswordAdmin />} />
        <Route path="/condolence/obituary-recipients" element={<CondolenceObituaryRecipients />} />
        <Route path="/condolence/mail-groups" element={<CondolenceMailGroups />} />
        <Route path="/condolence/employee-master" element={<CondolenceEmployeeMaster />} />
        <Route path="/condolence/invite" element={<CondolenceInvite />} />
        <Route path="*" element={<Navigate to="/condolence" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
